import {connect} from "react-redux";
import TagTransfer from "./TagTransfer";
import {bindActionCreators} from "redux";
import {
    getInactiveFsesRequest,
    tollById,
    getFseTagTransferRequest,
    callLogsRequest,
    tollPendingMeetingRequest,
    nearestPlazaFromOperatorLocationRequest
} from "../../../../service/FasttagToll/action";
import {documentUploadUrlPublic} from "../../../../service/fileUpload/action";

const mapStateToProps = (state) => ({
    getInactiveFsesResponse:state.FasttagToll.getInactiveFsesResponse,
    tollView:state.FasttagToll.tollView,
    getFseTagTransferResponse:state.FasttagToll.getFseTagTransferResponse,
    callLogsResponse:state.FasttagToll.callLogsResponse,
    tollPendingMeetingResponse:state.FasttagToll.tollPendingMeetingResponse,
    nearestPlazaFromOperatorLocationResponse:state.FasttagToll.nearestPlazaFromOperatorLocationResponse,
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getInactiveFsesRequest,
            tollById,
            getFseTagTransferRequest,
            callLogsRequest,
            tollPendingMeetingRequest,
            documentUploadUrlPublic,
            nearestPlazaFromOperatorLocationRequest
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(TagTransfer);
